var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('userroleview',{attrs:{"userroleinfo":_vm.userRoleInfo,"userrolecontacts":_vm.userRoleContacts,"orgcontacts":_vm.orgContacts,"allmodules":_vm.allModules},on:{"userRoleContactChange":_vm.getUserRoleContacts}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }